import { render } from "./HomeStatiscs.vue?vue&type=template&id=244ceddc&scoped=true"
import script from "./HomeStatiscs.vue?vue&type=script&lang=js"
export * from "./HomeStatiscs.vue?vue&type=script&lang=js"

import "./HomeStatiscs.vue?vue&type=style&index=0&id=244ceddc&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244ceddc"]])

export default __exports__